import React from 'react';

export type PortfolioTab = 'total' | 'etfs' | 'assets' | 'performance' | 'analytics' | 'chat';

interface PortfolioTabNavigationProps {
  activeTab: PortfolioTab;
  setActiveTab: (tab: PortfolioTab) => void;
}

const tabs: { key: PortfolioTab; label: string }[] = [
  { key: 'performance', label: 'Performance' },
  { key: 'total', label: 'Exposure' },
  { key: 'etfs', label: 'ETFs' },
  { key: 'assets', label: 'Assets' },
  { key: 'analytics', label: 'Analytics' },
  { key: 'chat', label: 'Ask' },
];

const PortfolioTabNavigation: React.FC<PortfolioTabNavigationProps> = ({ activeTab, setActiveTab }: PortfolioTabNavigationProps) => {
  return (
    <div className="d-flex gap-1 mb-4" style={{ borderBottom: '1px solid #f4f4f5', paddingBottom: '0' }}>
      {tabs.map(tab => (
        <button
          key={tab.key}
          onClick={() => setActiveTab(tab.key)}
          className="border-0 bg-transparent"
          style={{
            padding: '8px 16px',
            fontSize: '0.875rem',
            fontWeight: activeTab === tab.key ? 600 : 400,
            color: activeTab === tab.key ? '#000537' : '#71717a',
            borderBottom: activeTab === tab.key ? '2px solid #000537' : '2px solid transparent',
            marginBottom: '-1px',
            cursor: 'pointer',
            transition: 'color 0.15s ease',
            whiteSpace: 'nowrap',
          }}
          onMouseEnter={e => { if (activeTab !== tab.key) (e.currentTarget as HTMLElement).style.color = '#18181b'; }}
          onMouseLeave={e => { if (activeTab !== tab.key) (e.currentTarget as HTMLElement).style.color = '#71717a'; }}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};

export default PortfolioTabNavigation;
